import { Optional } from '../misc/Optional';
import { Value } from './Value';

export class Before implements Value<boolean> {
	private readonly result: Optional<boolean>;

	public constructor(value1: Value<Date>, value2: Value<Date>) {
		this.result = calculate(value1.getSingle(), value2.getSingle());
	}

	public isRepeatable(): boolean {
		return false;
	}

	public get(): ReadonlyArray<boolean> {
		return this.result !== null ? [this.result] : [];
	}

	public getSingle(): Optional<boolean> {
		return this.result;
	}
}

function calculate(value1: Optional<Date>, value2: Optional<Date>): Optional<boolean> {
	if (value1 !== null && value2 !== null) {
		return value1.getTime() < value2.getTime();
	}
	return null;
}
